import type { OrganizationCapability } from "@/types/organization-scope"

export const BUSINESS_REPORTS_CAPABILITY_CODE = "business_reports"

export type OrganizationCapabilityState =
  | "unknown"
  | "available"
  | "authorized-module-not-active"
  | "permission-not-granted"
  | "unavailable"

export interface ResolvedOrganizationCapability {
  state: OrganizationCapabilityState
  capability?: OrganizationCapability
}

export function resolveOrganizationCapability(
  capabilities: OrganizationCapability[] | null | undefined,
  code: string,
): ResolvedOrganizationCapability {
  if (capabilities == null) return { state: "unknown" }

  const capability = capabilities.find(item => item.code === code)
  if (!capability) return { state: "unavailable" }
  if (capability.available) return { state: "available", capability }
  if (!capability.authorized || capability.reasonCode === "PERMISSION_NOT_GRANTED") {
    return { state: "permission-not-granted", capability }
  }
  if (capability.reasonCode === "MODULE_NOT_ACTIVE") {
    return { state: "authorized-module-not-active", capability }
  }
  return { state: "unavailable", capability }
}

export function resolveBusinessReportsCapability(capabilities: OrganizationCapability[] | null | undefined) {
  return resolveOrganizationCapability(capabilities, BUSINESS_REPORTS_CAPABILITY_CODE)
}
